export const MINIMUM_QUERY_LENGTH_OF_SEARCH_INPUT = 3
